import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';

const styles = {
    top: {
        padding: 20,
        backgroundColor: 'white',
        width:'100%',
        borderBottomWidth:6,
        borderBottomColor:'#f5f5f5'
        
    }
}
class Title extends Component {
    render() {
        return (
            <div style={styles.top}>
                {
                    this.props.AddButton&&
                    <Button 
                    style={{float:'right'}}
                    onClick={()=>this.props.function()}
                    >
                    {this.props.AddButton}
                        <AddIcon />
                    </Button>
                }
                <Typography style={{ color: 'black' }} variant='display1'>
                    {this.props.title}
                </Typography>
                <Typography variant='subheading'>
                    {this.props.subTitle}/{this.props.title}
                </Typography>
            </div>
        );
    }
}

export default Title;


// WEBPACK FOOTER //
// ./src/components/Title.js